module.exports = __webpack_public_path__ + "static/media/middle-node-with-child.386356bd.svg";